import { gql } from "@apollo/client";

export default gql`
  mutation createCustomerBillingAddresses($data: CustomerBillingAddressesInput!){
    createCustomerBillingAddresses(data: $data){
        success
        data{
            _id
            customer
            accountingContactId
            country
            state
            city
            province
            postCode
            address1
            address2
            isCompany
            legalCompanyName
            taxOffice
            taxNumber
        }
        code
        message
    }
}
`
